import React, { useState } from "react";
import { Modal, ModalBody } from "@windmill/react-ui";

const ViewModal = ({ data, isOpen, onClose }) => {
  // var result = data.find(item => item.id === id);

  const [activeTab] = useState("1");

  const result = data;
  const style = `{
    .custom-modal button {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 16px;
      color: #333;
      outline:none !important;
    }
    .custom-modal button:hover {
      color: #FF0000 !important; 
      outline:none;
      
    } .custom-modal button:focus {
      color: #FF0000 !important; 
      outline:none; 
    }
    .custom-modal {
      overflow: auto;
    }
    
    `;

  const formattedDate = data
    ? `${new Date(data.created_at * 1000)
        .getDate()
        .toString()
        .padStart(2, "0")}-${(new Date(data.created_at * 1000).getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${new Date(data.created_at * 1000).getFullYear()}`
    : "";

  return (
    <>
      <style>{style}</style>

      <Modal
        className="relative bg-white dark:bg-gray-700 dark:text-white w-1/2 rounded-lg"
        isOpen={isOpen}
        onClose={() => {
          onClose();
        }}
      >
        <ModalBody className="custom-modal">
          <h2 className="text-center font-bold text-lg">Payment Details</h2>

          {/* Tab Content */}
          <div
            className="p-4"
            style={{
              maxHeight: "60vh",
              overflowY: "auto",
              scrollbarWidth: "thin",
            }}
          >
            {activeTab === "1" && (
              <div className="flow-root rounded-lg border-gray-100 py-3  ml-5 mb-5">
                <dl className="border rounded-lg border-gray-300 dark:border-gray-500 text-sm dark:text-white">
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Email
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.email}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Contact
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.contact}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Entity
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.entity}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Amount
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.amount}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Order ID{" "}
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.order_id}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Created At
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {formattedDate}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Status
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.status}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Order Id
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.order_id}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Method
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.method}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Bank
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.bank}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-gray-200">
                      Captured
                    </dt>
                    <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                      {result?.captured}
                    </dd>
                  </div>
                </dl>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default React.memo(ViewModal);
